import { Stack, styled } from '@mui/material';

import { generateClasses } from '../../../../../../../../utils/helper';

export const recordAttendanceDrawerStepperClasses = generateClasses('RecordAttendanceDrawerStepper', [
  'content',
]);

export const Root = styled(Stack)(({ theme }) => ({
  height: '100%',
  gap: theme.spacing(2),
  [`& .${recordAttendanceDrawerStepperClasses.content}`]: {
    flex: 1,
    '& > *': {
      height: '100%',
    },
  },
}));

export const Content = styled('div')(() => ({
  /** to allow children to handle scrollbar */
  overflow: 'hidden',
}));
